<script>
	export let params = {};

	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		API, 
		cabecalhoPadraoRequisicao,
		limparLocalStorage, 
		TextoFeedback, 
        TipoPerfil} from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let nome, email, unidade, area_interesse, captchaUsuario;

	let tituloAviso = "Erro";
	let unidades = [];
	let areas_interesse = [];
	let informacosAPICache = null;
	let usuario = {};
	
	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		const respostaUsuario = await fetch(API(`usuarios/${params.cpf}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await respostaUsuario.json();

		if (respostaUsuario.status == StatusHttp.OK) {
			usuario = dados;

			informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
			unidades = informacosAPICache.unidades;
			areas_interesse = Object.entries(informacosAPICache.areas_conhecimento).sort();

			nome = usuario.nome;
			email = usuario.email;
			unidade = usuario.unidade_const;
			area_interesse = usuario.area_interesse_const ?? "";
		} else {
			replace('#/usuario-inexistente');
		}

		// console.log(usuario);

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando os dados ...',
		});
		
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint atualizar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('usuarios'), {
				method: 'PATCH',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					id: usuario.id,
					nome: nome,
					email: email,
					unidade: unidade,
					area_interesse: area_interesse
				})
			}).catch(erros => {
				console.log(erros);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: TextoFeedback.ERRO_REQUISICAO
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			// pro método PATCH o retorno ideal é 204 (no-content) mas a API pode retornar mensagens úteis, ela envia 200 se a atualização for realizada.
			if (resposta.status == StatusHttp.OK) {
				/**
				 * Limpa o cache de listagem de usuário do fragmento da listagem se o paramêtro existir na url
				 * caso contrário limpa somente dadosUsuario pois neste caso é o usuário atualizando os próprios dados
				 */

				// limparToken, limparDadosUsuario, limparCacheUsuarios, limparCacheProjetos
				if (params.fragmentoCache == null)
					limparLocalStorage(false, true, false, false);
				else
					limparLocalStorage(false, false, true, false);
				
				// aguarda para a operação com localStorage ser finalizada (ver forma melhor de fazer isso)
				setTimeout( () => {
					replace('#/painel');
				}, 1000);

				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});
			} else {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: json?.mensagem
				});
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
		}
	}
</script>

<TBox 
	titulo="Atualização" 
	subtitulo="Formulário de atualização cadastral" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="cadastro">
	
	<p>
		Utilize o formulário abaixo para atualizar o cadastro. 
		Alguns dados não são permitidos de serem alterados pela aplicação. 
		Para alterar a senha utilize a opção "Recuperação" na tela de início.
		Caso seja necessário alteração de CPF e outros dados que precisam de validação cuidadosa, 
		solicitar via Suporte.
	</p>
	<hr>

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Nome:</small>
				<div class="field">
					<input 
						bind:value={nome}
						name="nome" 
						type="text" 
						class="input is-large is-primary" 
						autocomplete="name" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small class="has-text-primary">E-mail:</small>
				<div class="field">
					<input 
						bind:value={email}
						name="email" 
						type="email" 
						class="input is-large is-primary" 
						autocomplete="email" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Unidade:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={unidade} name="unidade">
						{#each Object.entries(unidades) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		{#if usuario.perfis?.includes(TipoPerfil.AVALIADOR)}
		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Área de interesse (avaliação):</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={area_interesse} name="area_interesse">
						<option value="">Área de interesse não cadastrada...</option>
						{#each areas_interesse as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		{/if}

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Atualizar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>